<template>
    <tr class="event__list_select_update_table_item">
        <td class="event__list_select_update_table_name">{{eventName}}</td>
        <td class="event__list_select_update_table_sessions">{{sessionsCount}}</td>
        <td class="event__list_select_update_table_sessionnext">{{sessionsNext}}</td>
        <td class="event__list_select_update_table_courses">{{sessionsCourses}}</td>
        <td class="event__list_select_update_table_status">
            <component-status :status="eventStatus"/>
        </td>
        <td class="event__list_select_update_table_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :theme="isSelected ? 'primary' : 'tertiary'"
                        :border="isSelected ? false : true"
                        :name="`event-list-select-update-table-actions-select-${eventId}`"
                        :disabled="sessionsCourses.length !== 0"
                        @click="performEmit('emit-selected', eventId)"
                    >{{ isSelected ? this.$t('ebs.events.list.buttons.selected') : this.$t('ebs.events.list.buttons.select') }}</component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import api from '@/api'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { fromObjectToStringComma, toLocaleDateTime } from '@/functions'

export default {
  components: { ComponentButton, ComponentStatus },
  name: 'event-list-select-update-table-item',
  data () {
    return {
      isSelected: false
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSecondStageTokenFromOldLMS () {
      return this.$store.getters.getAuthUserIsSecondStageTokenOldLMS
    },
    thumbnailUrl: function () {
      if (this.item.files.length) {
        return `${api.files}/file/${this.item.files[0].fileId}`
      }
      return false
    },
    eventId: function () {
      return this.item.id
    },
    eventName: function () {
      return this.item.name
    },
    eventStatus: function () {
      return this.item.status
    },
    sessionsCount: function () {
      return this.item.numberOfSessions
    },
    sessionsCourses: function () {
      return fromObjectToStringComma(this.item.courses, 'name')
    },
    sessionsNext: function () {
      return toLocaleDateTime(this.item.nextSessionDate)
    }
  },
  methods: {
    unselect: function () {
      this.isSelected = false
    },
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
      this.isSelected = true
    }
  },
  mounted () {
    this.$eventBus.$on('event-list-select-update-unselect', this.unselect)
  },
  beforeDestroy () {
    this.$eventBus.$off('event-list-select-update-unselect')
  }
}
</script>
